import React, { useCallback, useId } from 'react'
import { Checkbox, FormGroup } from '@theneatcompany/nui'
import PropTypes from 'prop-types'
import { useField, useFormikContext } from 'formik'
import cx from 'classnames'

import FieldError from '@/components/Forms/FieldError'

const CheckboxField = (props) => {
  const {
    inputProps = {},
    labelProps: { label } = {},
    errorProps = {},
    name,
    checked = false,
    onChange,
    className = '',
  } = props

  const id = useId()
  const [{ value }, { initialValue, error, touched }, { setTouched }] = useField(name)
  const { setFieldValue } = useFormikContext()

  const hasErrors = !!(error && touched)

  const handleOnChange = useCallback((e) => {
    const status = e.target.checked
    if (onChange) onChange(e)

    // If initial and selected values are equal (after coercion),
    // return the initial value
    // to ensure the form can get back to pristine state
    const updatedValue = (status === !!initialValue) ? initialValue : status
    setFieldValue(name, updatedValue)
  }, [onChange, name, value, setFieldValue, initialValue])

  return (
    <FormGroup
      intent={hasErrors ? 'danger' : 'default'}
      className={cx('checkbox-field', className)}
    >
      <Checkbox
        id={id}
        label={label}
        checked={checked || !!value}
        name={name}
        onChange={handleOnChange}
        onBlur={setTouched}
        status={hasErrors ? 'error' : undefined}
        {...inputProps}
      />
      <FieldError message={error} label={label} touched={touched} {...errorProps} />
    </FormGroup>
  )
}

CheckboxField.propTypes = {
  labelProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  }),
  inputProps: PropTypes.shape({}),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  errorProps: PropTypes.shape({}),
  className: PropTypes.string,
  name: PropTypes.string,
}

export default CheckboxField
